<template>
  <div class="card card--white">
    <div class="card--container">
      <h3>{{assessment.name}}</h3>
      <div class="small-top">Number of Attributes: {{assessment.attributes.length}}</div>
      <div class="">Number of Questions: {{assessment.num_of_questions}}</div>
      <div class="small-top">{{assessment.description}}</div>
      <div class="row small-top">
        <button class="btn" @click="createAssessment=true">Create Assessment</button>
        <button class="btn btn--flat" flat @click="reviewAttributes=true">Review Attributes</button>
      </div>
      <modal v-if="reviewAttributes" @close="reviewAttributes=false" :title="assessment.name" btn="Close" @submit="reviewAttributes=false">
        <div class="small-top" v-for="attribute in assessment.attributes" :key="attribute.id">
          <h4>{{attribute.name}}</h4>
          <div>{{attribute.description}}</div>
        </div>
      </modal>
      <coach-assessment-modal 
        :coachAssessment="newAssessment"
        :display="createAssessment"
        @close="createAssessment=false"
        @refresh="displayNewAssessment" />
      <modal v-if="success" @close="success=false" title="Success" btn="Close" @submit="success=false">
          <h2>Congrats!</h2>
          <div class="small-top">
            You just created a new assessment that you can share!
            Just share this link with your clients for them to take it.
          </div>
          <div class="small-top">
          <a :href="createdAssessment.link" target="_blank" class="small-top">
            {{createdAssessment.link}}
          </a>
          </div>
      </modal>
    </div>
  </div>
</template>

<script>
import modal from "@/components/modal/default";
import coachAssessmentModal from "../createModal";
import User from "@/services/api/authUser";

export default {
  props: ["assessment"],
  components: { modal, coachAssessmentModal },
  data() {
    return {
      reviewAttributes: false,
      createAssessment: false,
      success: false,
      newAssessment: {
        assessment: this.assessment.id,
        cta_img: User.user.image,
        cta_link: 'https://example.com',
        cta_title: 'Hey! Lets go over this',
        cta_link_text: 'Lets go'
      },
      createdAssessment: {}
    };
  },
  methods: {
    displayNewAssessment(newAssessment) {
      this.createdAssessment = newAssessment;
      this.success = true;
    }
  }
};
</script>

<style>

</style>
